import http from '../http'

const BASE_URL = 'user_sst'

class UserAPI {

  async save(userID, roleID, permissions) {
    const response = await http(`${BASE_URL + 's'}/save`, 'POST', {
      idsso: userID,
      rol_id: roleID,
      permisos: permissions
    })
    return response
  }

  async getAll() {
    const response = await http(`${BASE_URL}`)
    return response
  }

  async get(userID) {
    const response = await http(`${BASE_URL}/${userID}`)
    return response
  }

  async getSSO(userID) {
    const response = await http(`${BASE_URL}/ssoid/${userID}`)
    return response
  }

  async getDesign() {
    const response = await http(`${BASE_URL}_diseno`)
    return response
  }

  async getNotPaginate() {
    const response = await http(`noPaginateUsers`)
    return response
  }

  async update(userID, ssoID, roleID) {
    const response = await http(`${BASE_URL + 's'}/update/${userID}`, 'PUT', {
      idsso: ssoID,
      rol_id: roleID
    })
    return response
  }

  // Give permissions to user
  async giveSeveralPermissions(userID, permissions) {
    const response = await http(`user_sst_permission/${userID}`, 'POST', {
      permisos: permissions
    })
    return response
  }

  async givePermission(userID, permissionID) {
    const response = await http(`${BASE_URL}/${userID}`, 'POST', {
      permission_id: permissionID
    })
    return response
  }

  async removePermission(userID, permissionID) {
    const response = await http(`${BASE_URL}/permission/delete`, 'POST', {
      user_sst_id: userID,
      permissions_id: permissionID
    })
    return response
  }

}

export default new UserAPI()